import { Identifiable, KanbanTask, Project } from "@planzone/dto";
import { Filter as F } from "@planzone/dto";

interface Props {
  project: Identifiable<Project>;
}

enum StatusFilters {
  FINISHED = "kanban.filters.statuses.done",
  STARTED = "kanban.filters.statuses.started",
  PLANNED = "kanban.filters.statuses.planned",
}

enum Sorts {
  Default = "kanban.filters.sortFilter.filterOne",
  StartDate = "kanban.filters.sortFilter.filterTwo",
  EndDate = "kanban.filters.sortFilter.filterThree",
  FinishDate = "kanban.filters.sortFilter.filterFour",
  CreationDate = "kanban.filters.sortFilter.filterFive",
  LastEdit = "kanban.filters.sortFilter.filterSix",
}

type Sorters = {
  [key in Sorts]: (tasks: KanbanTask[]) => KanbanTask[];
};

type Filter = F & {
  statuses: StatusFilters[];
};

export type { Props, Sorters, Filter };

export { StatusFilters, Sorts };
